var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.5C1 3.94772 1.44772 3.5 2 3.5H22C22.5523 3.5 23 3.94772 23 4.5V19.5C23 20.0523 22.5523 20.5 22 20.5H2C1.44772 20.5 1 20.0523 1 19.5V4.5ZM3 5.5V18.5H21V5.5H3Z",
    fill: "#141415"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20006 3.90006C1.53143 3.45823 2.15823 3.36869 2.60006 3.70006L12.0001 10.7501L21.4001 3.70006C21.8419 3.36869 22.4687 3.45823 22.8001 3.90006C23.1314 4.34189 23.0419 4.96869 22.6001 5.30006L12.6001 12.8001C12.2445 13.0667 11.7556 13.0667 11.4001 12.8001L1.40006 5.30006C0.958231 4.96869 0.868688 4.34189 1.20006 3.90006Z",
    fill: "#141415"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.5C1 3.94772 1.44772 3.5 2 3.5H12C12.5523 3.5 13 3.94772 13 4.5C13 5.05228 12.5523 5.5 12 5.5H3V12C3 12.5523 2.55228 13 2 13C1.44772 13 1 12.5523 1 12V4.5Z",
    fill: "#141415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.5C11 3.94772 11.4477 3.5 12 3.5H22C22.5523 3.5 23 3.94772 23 4.5V12C23 12.5523 22.5523 13 22 13C21.4477 13 21 12.5523 21 12V5.5H12C11.4477 5.5 11 5.05228 11 4.5Z",
    fill: "#141415"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.775ef447cddd7ddace7808ed8f8fe4d8.svg";
export { ForwardRef as ReactComponent };